import { store } from '@betacrew/jars-flux'
export const componentKey = "MANAGE_PERMISSIONS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPermissions : (state, action) => {
            state.permissions = action.payload;
        },
        setThresholdAmount : (state, action) => {
            state.thresholdAmount = action.payload;
        },
        setRightsLabels: (state, action) => {
            state.rightsLabels = action.payload;
        },
        setDisabledPermissions: (state, action) => {
            state.disabledPermissions = action.payload;
        },
    }, 
    initialReducerState: {
        permissions: [],
        thresholdAmount: 0,
        rightsLabels: [],
        disabledPermissions: [],
        loadingState: false,
    }
});
export const { setLoadingState, setPermissions, setThresholdAmount, setRightsLabels, setDisabledPermissions } = actions;